import { render, staticRenderFns } from "./ConfiguracoesEdit.vue?vue&type=template&id=2e7f3266"
import script from "./ConfiguracoesEdit.vue?vue&type=script&lang=js"
export * from "./ConfiguracoesEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports